import { useTranslation } from "react-i18next";
import { cn } from "@/core/helpers/cn.ts";
import formatPrice from "@/core/helpers/formatPrice.ts";
import FeeSelectDaysSlider from "@/shared/widgets/FeeSelectDaysSlider";

type Props = {
  totalFee: number;
  maxDays: number;
  selectedDays: number;
  i18fileName: string;
  setSelectedDays: (arg0: number) => void;
  className?: string;
  color?: "lightBlue";
};

export default function FeeForm({
  totalFee,
  maxDays,
  selectedDays,
  i18fileName,
  setSelectedDays,
  className,
  color,
}: Props) {
  const { t } = useTranslation(i18fileName);

  const step = 1;
  const availableDays = [];
  for (let i = 0; i <= maxDays; i += step) {
    availableDays.push(i);
  }

  if (maxDays % step !== 0 && !availableDays.includes(maxDays)) {
    availableDays.push(maxDays);
  }

  const sliderMax = Math.ceil(maxDays / step) * step;

  return (
    <div className={cn("flex flex-col gap-5 flex-grow justify-between", className)}>
      <div className="flex flex-col">
        <div className="flex items-center justify-between px-1">
          <div className="text-16 font-medium text-white">{t(`${i18fileName}.fee.payPerDay`)}:</div>
          <div className="text-16 font-bold text-accent-solid">{formatPrice(totalFee)} ₽</div>
        </div>
        <div className="border-t border-t-[#191919] py-5 mt-5 overflow-clip">
          <div className="flex items-center justify-between px-1">
            <div className="text-16 font-bold text-white">{t(`${i18fileName}.fee.days`)}:</div>
            <div className="text-16 font-bold text-accent-solid">{maxDays === 0 ? 1 : maxDays}</div>
          </div>
          <FeeSelectDaysSlider
            value={maxDays === 0 ? 1 : selectedDays}
            values={maxDays === 0 ? [0, 1] : availableDays}
            min={0}
            max={maxDays === 0 ? 1 : sliderMax}
            step={step}
            onChange={setSelectedDays}
            className="mt-3.5 px-2"
            classNameLabel="text-white/40"
            classNameSlider={
              color === "lightBlue" &&
              "[&_.rt-SliderRange]:bg-gradient-lightBlue [&_.rt-SliderThumb]:[&_::after]:!bg-gradient-lightBlue"
            }
          />
        </div>
      </div>
    </div>
  );
}
